export const DEFAULT_TABLE_PAGE_SIZE = 15;

export const VALID_UNTIL_MAX_DAYS = 7;

export const SESSION_TIMEOUT_MS = 1000 * 60 * 5;